export default "__VITE_ASSET__cb2deb7d__"